import { Component, Element, Host, Prop, VNode, h } from '@stencil/core';
import { guid } from '../../utils';
import { Weight } from './types';

/** @slot - Adds label text. */
@Component({
  shadow: true,
  styleUrl: 'label.css',
  tag: 'abds-label',
})
export class Label {
  //--------------------------------------------------------------------------
  //
  //  Element
  //
  //--------------------------------------------------------------------------

  @Element() host: HTMLAbdsLabelElement;

  //--------------------------------------------------------------------------
  //
  //  Props
  //
  //--------------------------------------------------------------------------

  /**
   * Displays red asterisk if true. Has no impact on form submission.
   *
   * **Note:** A required label without text will display a red asterisk with no
   * context. To prevent this the implementation should not render the label
   * at all if no text is present to display.
   */
  @Prop({ reflect: true }) required = false;

  /** Tooltip text to display on abds-icon hover. */
  @Prop({ reflect: true }) tooltip: string;

  /** Displays label in bold or medium font-weight. */
  @Prop({ reflect: true }) weight: Weight = 'semibold';

  //--------------------------------------------------------------------------
  //
  //  Lifecycle Methods
  //
  //--------------------------------------------------------------------------

  render(): VNode {
    const iconGuid = `icon-${guid()}`;
    const tooltipGuid = `tooltip-${guid()}`;

    return (
      <Host>
        <slot />
        {this.tooltip && (
          <abds-icon
            aria-describedby={tooltipGuid}
            icon="information-circle"
            id={iconGuid}
            size="md"
            stroke-width="medium"
            tabIndex={0}
          ></abds-icon>
        )}
        {this.tooltip && (
          <abds-tooltip for={iconGuid} id={tooltipGuid} placement="top">
            {this.tooltip}
          </abds-tooltip>
        )}
      </Host>
    );
  }
}
